// extracted by mini-css-extract-plugin
module.exports = {"form":"U4BFpJ","title":"smqHgz","text":"mN_Yyy","label":"NFwQIF","formGroup":"VRvTYH","input":"TT8gB_","button":"_4y1Odb"};